import { styled } from 'styled-components';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';

export const StepContainer = styled(Flex)
    .withConfig({ displayName: 'StepContainer' })
    .attrs((props) => ({
        ...props,
        direction: 'row',
        alignItems: 'center',
        position: 'relative',
    }))`
    &:not(:last-child) {
        margin-bottom: 16px;
    }

    &:not(:last-child)::after {
        content: '';
        position: absolute;
        left: 22px;
        top: 100%;
        width: 4px;
        height: 16px;
        background-color: var(--control-secondary-background);
    }
`;

export const IconContainer = styled(Flex)
    .withConfig({ displayName: 'IconContainer' })
    .attrs((props) => ({
        ...props,
        width: 48,
        height: 48,
        borderRadius: '50%',
        backgroundColor: 'var(--control-secondary-background)',
        alignItems: 'center',
        justifyContent: 'center',
        mr: 1.25,
        flexShrink: 0,
    }))`
`;

export const StepText = styled(Typography)
    .withConfig({ displayName: 'StepText' })
    .attrs((props) => ({
        ...props,
        variant: 'body2',
        weight: 'regular',
        color: 'primary',
    }))``;
